<template>
  <div class="Task-modal-overlay" @click="close">
    <transition name="modal-expand">
      <div v-if="isVisible" class="Task-modal" @click.stop>
        <div class="modal-content-progress" @click.stop>
          <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
          <div class="Task-modal-header">
            <div class="Task-modal-dialog">
              <h5 style="padding: 10px;" class="Task-modal-title">Progress of Trainee: {{ traineeName }}
              </h5>
            </div>
          </div>
          <div>
            <ul class="nav nav-tabs">
              <li v-if="!ENABLE_CUSTOM_PROGRESS" class="nav-item">
                <a class="nav-link" :class="{ active: currentTab === 'chapters' }"
                  @click.stop="currentTab = 'chapters'">Chapters</a>
              </li>
              <li v-if="!ENABLE_CUSTOM_PROGRESS" class="nav-item">
                <a class="nav-link" :class="{ active: currentTab === 'scope' }"
                  @click.stop="currentTab = 'scope'">Scope</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: currentTab === 'chapterScope' }"
                  @click.stop="currentTab = 'chapterScope'">Chapter-Scope</a>
              </li>
              <li v-if="ENABLE_ASSESSMENT" class="nav-item">
                <a class="nav-link" :class="{ active: currentTab === 'assessments' }"
                  @click.stop="currentTab = 'assessments'">Assessments</a>
              </li>
            </ul>
            <table class="data-table" v-if="currentTab === 'chapters' && !ENABLE_CUSTOM_PROGRESS">
              <thead>
                <tr style="border-bottom: 2px solid black;">
                  <th style="width: 800px; border-right: 2px solid black;" rowspan="2">Chapter</th>
                  <th style="border-right: 2px solid black;" colspan="3">Total Tasks</th>
                  <th style="border-right: 2px solid black;" colspan="3">Main Tasks</th>
                  <th style="border-right: 2px solid black;" colspan="3">Additional Tasks</th>
                </tr>
                <tr style="border-bottom: 2px solid black;">
                  <th style="text-align: center;">Total</th>
                  <th style="text-align: center;"># Complete</th>
                  <th style="border-right: 2px solid black; text-align: center;">% Complete</th>
                  <th style="text-align: center;">Total</th>
                  <th style="text-align: center;"># Complete</th>
                  <th style="border-right: 2px solid black; text-align: center;">% Complete</th>
                  <th style="text-align: center;">Total</th>
                  <th style="text-align: center;"># Complete</th>
                  <th style="border-right: 2px solid black; text-align: center;">% Complete</th>
                </tr>
              </thead>
              <tbody>
              <tr class="total-row">
                <td class="first_column" style="border-right: 2px solid black;"><strong>Overall</strong></td>
                <td style="text-align: center;">{{ totalTasks }}</td>
                <td style="text-align: center;">{{ totalCompleted }}</td>
                <td style="border-right: 2px solid black; text-align: center;">{{ totalPercentage }}</td>
                <td style="text-align: center;">{{ totalMandatory }}</td>
                <td style="text-align: center;">{{ totalMainCompleted }}</td>
                <td style="border-right: 2px solid black; text-align: center;" :class="{
                  'highlight-green': parseFloat(totalManobPercentage) >= passRate,
                  'highlight-orange': parseFloat(totalManobPercentage) < passRate
                }">{{ totalManobPercentage }}</td>
                <td style="text-align: center;">{{ totalAdditional }}</td>
                <td style="text-align: center;">{{ totalAdditionalCompleted }}</td>
                <td style="border-right: 2px solid black; text-align: center;">
                  {{ totalAdditionalPercentage }}
                </td>
              </tr>
              <tr v-for="chapter in filteredChapters" :key="chapter.id">
                <td class="first_column" style="border-right: 2px solid black;"><strong>{{ chapter.chapt_no }}: {{ chapter.name }}</strong></td>
                <td style="text-align: center;">{{ chapter.tasks.all.length }}</td>
                <td style="text-align: center;">{{ chapter.tasks.completed.length }}</td>
                <td style="border-right: 2px solid black; text-align: center;">
                  {{ chapter.tasks.all.length === 0 ? '100.0%' : (chapter.tasks.completed.length /
                    chapter.tasks.all.length * 100).toFixed(1) + '%' }}
                </td>
                <td style="text-align: center;">{{ chapter.tasks.manob.length }}</td>
                <td style="text-align: center;">{{ chapter.tasks.main_completed.length }}</td>
                <td style="border-right: 2px solid black; text-align: center;">
                  {{ chapter.tasks.manob.length === 0 ? '100.0%' : (chapter.tasks.main_completed.length /
                    chapter.tasks.manob.length * 100).toFixed(1) + '%' }}
                </td>
                <td style="text-align: center;">{{ chapter.tasks.additional.length }}</td>
                <td style="text-align: center;">{{ chapter.tasks.additional_completed.length }}</td>
                <td style="border-right: 2px solid black; text-align: center;">
                  {{ chapter.tasks.additional.length === 0
                    ? '100.0%'
                    : (chapter.tasks.additional_completed.length / chapter.tasks.additional.length * 100).toFixed(1) + '%' }}
                </td>
              </tr>
              <tr class="mandatory-tasks-row">
                <td colspan="10" class="grey-column"><strong>The percentage of main tasks completed must be > {{ passRate }}%</strong></td>
              </tr>
              </tbody>
            </table>
            <table class="data-table" v-if="currentTab === 'scope'">
              <thead>
                <tr style="border-bottom: 2px solid black;">
                  <th style="width: 700px; border-right: 2px solid black;" rowspan="2">Chapter</th>
                  <th style="border-right: 2px solid black;" colspan="3">Total Tasks</th>
                  <th style="border-right: 2px solid black;" colspan="3">Main Tasks</th>
                  <th style="border-right: 2px solid black;" colspan="3">Additional Tasks</th>
                </tr>
                <tr style="border-bottom: 2px solid black;">
                  <th style="text-align: center;">Total</th>
                  <th style="text-align: center;"># Complete</th>
                  <th style="border-right: 2px solid black; text-align: center;">% Complete</th>
                  <th style="text-align: center;">Total</th>
                  <th style="text-align: center;"># Complete</th>
                  <th style="border-right: 2px solid black; text-align: center;">% Complete</th>
                  <th style="text-align: center;">Total</th>
                  <th style="text-align: center;"># Complete</th>
                  <th style="border-right: 2px solid black; text-align: center;">% Complete</th>
                </tr>
              </thead>
              <tbody>
                <tr class="total-row">
                  <td class="first_column" style="border-right: 2px solid black;"><strong>Overall</strong></td>
                  <td style="text-align: center;">{{ totalScopeTasks }}</td>
                  <td style="text-align: center;">{{ totalScopeCompleted }}</td>
                  <td style="border-right: 2px solid black; text-align: center;">{{ totalScopePercentage }}</td>                 
                  <td style="text-align: center;">{{ totalScopeMandatory }}</td>
                  <td style="text-align: center;">{{ totalScopeMainCompleted }}</td>
                  <td style="border-right: 2px solid black; text-align: center;" :class="{
                    'highlight-green': parseFloat(totalManobScopePercentage) >= passRate,
                    'highlight-orange': parseFloat(totalManobScopePercentage) < passRate
                  }">{{ totalManobScopePercentage }}</td>
                  <td style="text-align: center;">{{ totalScopeAdditional }}</td>
                  <td style="text-align: center;">{{ totalScopeAdditionalCompleted }}</td>
                  <td style="border-right: 2px solid black; text-align: center;">
                    {{ totalScopeAdditionalPercentage }}
                  </td>
                </tr>
                <tr v-for="(tasks, scope) in groupedTasksByScope" :key="scope">
                  <td class="first_column" style="border-right: 2px solid black;"><strong>{{ scope }}</strong></td>
                  <td style="text-align: center;">{{ tasks.all.length }}</td>
                  <td style="text-align: center;">{{ tasks.completed.length }}</td>
                  <td style="border-right: 2px solid black; text-align: center;">
                    {{ tasks.all.length === 0 ? '100.0%' : (tasks.completed.length / tasks.all.length * 100).toFixed(1)
                      + '%'
                    }}
                  </td>
                  <td style="text-align: center;">{{ tasks.manob.length }}</td>
                  <td style="text-align: center;">{{ tasks.main_completed.length }}</td>
                  <td style="border-right: 2px solid black; text-align: center;">
                    {{ tasks.manob.length === 0 ? '100.0%' : (tasks.main_completed.length / tasks.manob.length *
                      100).toFixed(1) + '%' }}
                  </td>
                  <td style="text-align: center;">{{ tasks.additional.length }}</td>
                  <td style="text-align: center;">{{ tasks.additional_completed.length }}</td>
                  <td style="border-right: 2px solid black; text-align: center;">
                    {{ tasks.additional.length === 0
                      ? '100.0%'
                      : (tasks.additional_completed.length / tasks.additional.length * 100).toFixed(1) + '%' }}
                  </td>
                </tr>
                <tr>
                  <td colspan="10" class="grey-column" ><strong>The percentage of main tasks completed must be > {{ passRate }}%</strong></td>
                </tr>
              </tbody>
            </table>
            <table class="data-table" v-if="currentTab === 'chapterScope' && ENABLE_CUSTOM_PROGRESS">
              <thead>
                <tr>
                  <th style="min-width: 250px;" rowspan="2">Chapter / Scope</th>
                  <th :colspan="sortedScopes.length">B1</th>
                  <th :colspan="sortedScopes.length" style="border-left: 2px solid black;">B2</th>
                  <th rowspan="2">% Completed</th>
                </tr>
                <tr>
                  <th v-for="scope in sortedScopes" :key="'B1-' + scope">{{ scope }}</th>
                  <th v-for="(scope, index) in sortedScopes" :key="'B2-' + scope" :class="{ 'b2-border': index === 0 }">
                    {{ scope
                    }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="chapter in filteredChaptersWithMandatory" :key="chapter.chapt_no">
                  <td><strong>{{ chapter.chapt_no }}: {{ chapter.name }}</strong></td>
                  <td v-for="scope in sortedScopes" :key="'B1-' + scope">
                    <span v-if="chapterScopeTaskCounts[chapter.chapt_no]?.[scope]?.B1?.total"
                      :class="getTickClass(chapterScopeTaskCounts[chapter.chapt_no][scope].B1)">
                      ✔
                    </span>
                  </td>
                  <td v-for="(scope, index) in sortedScopes" :key="'B2-' + scope" :class="{ 'b2-border': index === 0 }">
                    <span v-if="chapterScopeTaskCounts[chapter.chapt_no]?.[scope]?.B2?.total"
                      :class="getTickClass(chapterScopeTaskCounts[chapter.chapt_no][scope].B2)">
                      ✔
                    </span>
                  </td>
                  <td :class="{
                    'highlight-green': chapter.tasks.manob.length && getCompletedScopePercentage(chapter) >= 50,
                    'highlight-orange': chapter.tasks.manob.length && getCompletedScopePercentage(chapter) < 50
                  }">
                    {{ getCompletedScopePercentage(chapter).toFixed(1) }}%
                  </td>
                </tr>
                <tr class="total-row">
                  <td><strong>Total</strong></td>
                  <td v-for="scope in sortedScopes" :key="'B1-total-' + scope">
                    {{ tickStats[scope].B1.ticks }}
                  </td>
                  <td v-for="(scope, index) in sortedScopes" :key="'B2-total-' + scope"
                    :class="{ 'b2-border': index === 0 }">
                    {{ tickStats[scope].B2.ticks }}
                  </td>
                  <td><strong>{{ overallTickStats.totalTicks }}</strong></td>
                </tr>
                <tr class="total-row">
                  <td><strong>Total Completed <br>% Complete</strong></td>
                  <td v-for="scope in sortedScopes" :key="'B1-complete-' + scope" :class="{
                    'highlight-green': tickStats[scope].B1.blueTicks >= Math.ceil(tickStats[scope].B1.ticks * (scopePercentages[scope] / 100)),
                    'highlight-orange': tickStats[scope].B1.blueTicks < Math.ceil(tickStats[scope].B1.ticks * (scopePercentages[scope] / 100))
                  }">
                    {{ tickStats[scope].B1.blueTicks }} <br>
                    {{ tickStats[scope].B1.ticks ? ((tickStats[scope].B1.blueTicks / tickStats[scope].B1.ticks) *
                      100).toFixed(1) : '0.0' }}%
                  </td>

                  <td v-for="(scope, index) in sortedScopes" :key="'B2-complete-' + scope" :class="[
                    index === 0 ? 'b2-border' : '',
                    tickStats[scope].B2.blueTicks >= Math.ceil(tickStats[scope].B2.ticks * (scopePercentages[scope] / 100))
                      ? 'highlight-green'
                      : 'highlight-orange'
                  ]">
                    {{ tickStats[scope].B2.blueTicks }} <br>
                    {{ tickStats[scope].B2.ticks ? ((tickStats[scope].B2.blueTicks / tickStats[scope].B2.ticks) *
                      100).toFixed(1) : '0.0' }}%
                  </td>
                  <td :class="{
                    'highlight-green': parseFloat(totalManobScopePercentage) >= 50,
                    'highlight-orange': parseFloat(totalManobScopePercentage) < 50
                  }">
                    {{ overallTickStats.totalBlue }} <br>
                    {{ overallTickStats.totalTicks ? ((overallTickStats.totalBlue / overallTickStats.totalTicks) * 100).toFixed(1) : '0.0' }}%
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="data-table" v-if="currentTab === 'chapterScope' && !ENABLE_CUSTOM_PROGRESS">
              <thead>
                <tr style="border-bottom: 2px solid black;">
                  <th style="width: 700px; border-right: 2px solid black;">Chapter / Scope</th>
                  <th style="text-align: center;" v-for="scope in sortedScopes" :key="scope">
                    {{ scope }}
                  </th>
                  <th style="border-left: 2px solid black; text-align: center;">% Completed</th>
                </tr>
              </thead>
              <tbody>
                <tr class="total-row">
                  <td style="border-right: 2px solid black;"><strong>Total</strong></td>
                  <td style="text-align: center;" v-for="scope in sortedScopes" :key="scope">
                    {{ getScopeTotalDefault(scope).mandatory }}
                  </td>
                  <td style="border-left: 2px solid black; text-align: center;">
                    {{ totalScopeMandatory }}
                  </td>
                </tr>
                <tr class="total-row">
                  <td style="border-right: 2px solid black;"><strong>Total Completed</strong></td>
                  <td style="text-align: center;" v-for="(scope) in sortedScopes" :key="scope">
                    {{ getScopeTotalDefault(scope).mandatory_complete }}
                  </td>
                  <td style="border-left: 2px solid black; text-align: center;" :class="{
                    'highlight-green': parseFloat(totalManobScopePercentageDefault) >= passRate,
                    'highlight-orange': parseFloat(totalManobScopePercentageDefault) < passRate
                  }">
                    {{ totalScopeMainCompletedDefault }}
                  </td>
                </tr>
                <tr class="total-row">
                  <td style="border-right: 2px solid black;"><strong>% Complete</strong></td>
                  <td style="text-align: center;" v-for="(scope, index) in sortedScopes" :key="scope">
                    {{ percentageMandatoryCompletePerScope[index] }}
                  </td>
                  <td style="border-left: 2px solid black; text-align: center;" :class="{
                    'highlight-green': parseFloat(totalManobPercentageDefault) >= passRate,
                    'highlight-orange': parseFloat(totalManobPercentageDefault) < passRate
                  }">
                    {{ totalManobPercentageDefault }}
                  </td>
                </tr>
                <tr v-for="chapter in filteredMandatoryChapters" :key="chapter.chapt_no">
                  <td style="border-right: 2px solid black;"><strong>{{ chapter.chapt_no }}: {{ chapter.name }}</strong></td>
                  <td style="text-align: center;" v-for="scope in sortedScopes" :key="scope">
                    {{ chapterScopeTaskCountsDefault[chapter.chapt_no]?.[scope]?.mandatory || '' }}
                    <span v-if="chapterScopeTaskCountsDefault[chapter.chapt_no]?.[scope]?.mandatory">
                      ({{ chapterScopeTaskCountsDefault[chapter.chapt_no]?.[scope]?.main_completed }})
                    </span>
                  </td>
                  <td style="border-left: 2px solid black; text-align: center;">
                    {{ chapter.tasks.manob.length ? (chapter.tasks.main_completed.length / chapter.tasks.manob.length *
                      100).toFixed(1) + '%' : '0.0%' }}
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="data-table" style="text-align: left;" v-if="currentTab === 'assessments'">
              <thead>
                <tr>
                  <th style="width: 60px;">Attempt</th>
                  <th style="width: 60px;">ATA</th>
                  <th style="width: 80px;">Category</th>
                  <th>Question</th>
                  <th style="width: 100px;">Assessment Type</th>
                  <th style="width: 60px;">Result</th>
                  <th style="width: 80px;">Date</th>
                  <th style="width: 100px;">Status</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="task in mergedAssessments" :key="task.assessment_task_id">
                  <tr v-for="item in task.assessments" :key="item.id">
                    <td style="width: 60px;"><strong>{{ item.attempt_no }}</strong></td>
                    <td style="width: 60px;">{{ task.chapt_no }}</td>
                    <td style="width: 80px;">{{ task.category }}</td>
                    <td>{{ task.question }}</td>
                    <td style="width: 100px;">{{ task.assessment_type }}</td>

                    <td :class="item.result === 'pass' ? 'pass' : 'fail'" style="width: 60px;">
                      {{ item.result.charAt(0).toUpperCase() + item.result.slice(1) }}
                    </td>
                    <td style="width: 80px;">{{ formatDate(item.date) }}</td>
                    <td :class="item.is_submitted > 3 ? 'submitted' : 'in-progress'" style="width: 100px;">
                      {{ item.is_submitted > 3 ? 'Submitted' : 'In progress' }}
                    </td>
                  </tr>
                </template>

                <tr v-if="mergedAssessments.length === 0">
                  <td colspan="100" style="text-align: center;">Trainee has no assessments completed</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { ENABLE_CUSTOM_PROGRESS as ENABLE_CUSTOM_PROGRESS_FLAG, ENABLE_ASSESSMENT as ENABLE_ASSESSMENT_FLAG } from '@/config/featureFlags';

export default {
  props: {
    mergedTasks: {
      type: Array,
      required: true
    },
    traineeId: {
      type: Number,
      required: true
    },
    logbookId: {
      type: Number,
      required: true
    },
    passRate: { 
      type: Number, 
      default: 50 
    }
  },
  data() {
    return {
      showTaskLongFormModal: true,
      chapters: [],
      assessments: [],
      mergedAssessments: [],
      currentTab: ENABLE_CUSTOM_PROGRESS_FLAG ? 'chapterScope' : 'chapters',
      traineeUID: '',
      traineeName: '',
      scopePercentages: {
        INS: 50,
        FOT: 50,
        SGH: 50,
        'R/I': 50,
        MEL: 50,
        TS: 50,
        LOC: 50
      },
      isVisible: false,
    };
  },
  computed: {
    ENABLE_CUSTOM_PROGRESS() {
      return ENABLE_CUSTOM_PROGRESS_FLAG;
    },
    ENABLE_ASSESSMENT() {
      return ENABLE_ASSESSMENT_FLAG;
    },
    // Custom progress counts a task once the instructor signs it off, the default once the trainee completes it
    doneKey() {
      return ENABLE_CUSTOM_PROGRESS_FLAG ? 'ins_so' : 'completed';
    },
    mainDoneKey() {
      return ENABLE_CUSTOM_PROGRESS_FLAG ? 'main_ins_so' : 'main_completed';
    },
    filteredChapters() {
      return this.chapters.filter(chapter => chapter.tasks.all.length > 0);
    },
    filteredMandatoryChapters() {
      return this.chapters.filter(chapter => chapter.tasks.manob.length > 0);
    },
    totalTasks() {
      return this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks.all.length, 0);
    },
    totalMandatory() {
      return this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks.manob.length, 0);
    },
    totalCompleted() {
      return this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks[this.doneKey].length, 0);
    },
    totalMainCompleted() {
      return this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks[this.mainDoneKey].length, 0);
    },
    totalEnabled() {
      return this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks.enabled.length, 0);
    },
    totalIncomplete() {
      return this.filteredChapters.reduce((acc, chapter) => acc + (chapter.tasks.enabled.length - chapter.tasks[this.doneKey].length), 0);
    },
    totalCompletePercentage() {
      const totalCompleted = this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks[this.doneKey].length, 0);
      const total = this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks.all.length, 0);
      return ((totalCompleted / total) * 100).toFixed(1) + '%';
    },
    totalManobPercentage() {
      const totalMainCompleted = this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks[this.mainDoneKey].length, 0);
      const totalMandatory = this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks.manob.length, 0);
      if (totalMandatory === 0) {
        return '100.0%';
      }
      return ((totalMainCompleted / totalMandatory) * 100).toFixed(1) + '%';
    },
    totalPercentage() {
      const totalCompleted = this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks[this.doneKey].length, 0);
      const total = this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks.all.length, 0);
      return ((totalCompleted / total) * 100).toFixed(1) + '%';
    },
    totalAdditional() {
      return this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks.additional.length, 0);
    },
    totalAdditionalCompleted() {
      return this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks.additional_completed.length, 0);
    },
    totalAdditionalPercentage() {
      if (this.totalAdditional === 0) return '100.0%';
      return ((this.totalAdditionalCompleted / this.totalAdditional) * 100).toFixed(1) + '%';
    },
    groupedTasksByScope() {
      const groupedScopeTasks = {};

      this.mergedTasks.forEach(task => {
        if (!groupedScopeTasks[task.scope]) {
          groupedScopeTasks[task.scope] = {
            all: [],
            manob: [],
            completed: [],
            ins_so: [],
            enabled: [],
            main_completed: [],
            main_ins_so: [],
            additional: [],
            additional_completed: [],
          };
        }
        groupedScopeTasks[task.scope].all.push(task);
        const isMainTask = task.manob === 'MT' && task.is_exam === 0;
        if (isMainTask) {
          groupedScopeTasks[task.scope].manob.push(task);
          if (task.completed) {
            groupedScopeTasks[task.scope].main_completed.push(task);
          }
          if (task.ins_so) {
            groupedScopeTasks[task.scope].main_ins_so.push(task);
          }
        } else {
          groupedScopeTasks[task.scope].additional.push(task);
          if (task.completed) {
            groupedScopeTasks[task.scope].additional_completed.push(task);
          }
        }

        if (task.enabled) {
          groupedScopeTasks[task.scope].enabled.push(task);
        }
        if (task.completed) {
          groupedScopeTasks[task.scope].completed.push(task);
        }
        if (task.ins_so) {
          groupedScopeTasks[task.scope].ins_so.push(task);
        }
      });

      // Order the scopes by their percentage
      const orderedScopes = Object.keys(groupedScopeTasks).sort((scopeA, scopeB) => {
        return (this.scopePercentages[scopeB] || 0) - (this.scopePercentages[scopeA] || 0);
      });

      // Create a new object with ordered scopes
      const orderedGroupedTasks = {};
      orderedScopes.forEach(scope => {
        orderedGroupedTasks[scope] = groupedScopeTasks[scope];
      });

      return orderedGroupedTasks;
    },
    totalScopeTasks() {
      return Object.values(this.groupedTasksByScope).reduce((acc, tasks) => acc + tasks.all.length, 0);
    },
    totalScopeMandatory() {
      return Object.values(this.groupedTasksByScope).reduce((acc, tasks) => acc + tasks.manob.length, 0);
    },
    totalScopeCompleted() {
      return Object.values(this.groupedTasksByScope).reduce((acc, tasks) => acc + tasks[this.doneKey].length, 0);
    },
    totalScopeMainCompleted() {
      return Object.values(this.groupedTasksByScope).reduce((acc, tasks) => acc + tasks[this.mainDoneKey].length, 0);
    },
    totalScopeEnabled() {
      return Object.values(this.groupedTasksByScope).reduce((acc, tasks) => acc + tasks.enabled.length, 0);
    },
    totalScopeIncomplete() {
      return Object.values(this.groupedTasksByScope).reduce((acc, tasks) => {
        const totalCompleted = tasks.completed.length;
        const totalEnabled = tasks.enabled.length;
        return acc + (totalEnabled - totalCompleted);
      }, 0);
    },
    totalManobScopePercentage() {
      const totalMainCompleted = Object.values(this.groupedTasksByScope).reduce((acc, tasks) => { return acc + tasks[this.mainDoneKey].length; }, 0);
      const totalMandatory = Object.values(this.groupedTasksByScope).reduce((acc, tasks) => { return acc + tasks.manob.length; }, 0);
      if (totalMandatory === 0) {
        return '100.0%';
      }
      return ((totalMainCompleted / totalMandatory) * 100 || 0).toFixed(1) + '%';
    },
    totalScopePercentage() {
      const totalCompleted = Object.values(this.groupedTasksByScope).reduce((acc, tasks) => { return acc + tasks[this.doneKey].length; }, 0);
      const total = Object.values(this.groupedTasksByScope).reduce((acc, tasks) => { return acc + tasks.all.length; }, 0);
      return ((totalCompleted / total) * 100 || 0).toFixed(1) + '%';
    },
    totalScopeAdditional() {
      return Object.values(this.groupedTasksByScope).reduce((acc, tasks) => acc + tasks.additional.length, 0);
    },
    totalScopeAdditionalCompleted() {
      return Object.values(this.groupedTasksByScope).reduce((acc, tasks) => acc + tasks.additional_completed.length, 0);
    },
    totalScopeAdditionalPercentage() {
      if (this.totalScopeAdditional === 0) return '100.0%';
      return ((this.totalScopeAdditionalCompleted / this.totalScopeAdditional) * 100).toFixed(1) + '%';
    },
    chapterScopeTaskCounts() {
      const taskCounts = {};

      // Initialize task counts per chapter-scope combination
      this.mergedTasks.forEach(task => {
        if (task.manob !== 'MT') return; // Skip non-mandatory tasks
        const { chapt_no, scope, category } = task;

        // Initialize chapter if it doesn't exist
        if (!taskCounts[chapt_no]) {
          taskCounts[chapt_no] = {};
        }

        // Initialize scope if it doesn't exist within the chapter
        if (!taskCounts[chapt_no][scope]) {
          taskCounts[chapt_no][scope] = {
            B1: { total: 0, completed: 0, ins_so: 0 },
            B2: { total: 0, completed: 0, ins_so: 0 },
          };
        }

        const categories = category.split(' ');
        categories.forEach(cat => {
          if (cat === 'B1' || cat === 'B2') {
            taskCounts[chapt_no][scope][cat].total++;
            if (task.completed) {
              taskCounts[chapt_no][scope][cat].completed++;
            }
            if (task.ins_so) {
              taskCounts[chapt_no][scope][cat].ins_so++;
            }
          }
        });

      });

      return taskCounts;
    },
    // Collect unique scopes for column headers
    availableScopes() {
      const scopes = new Set();
      this.mergedTasks.forEach(task => {
        if (task.scope) {
          scopes.add(task.scope);
        }
      });
      return Array.from(scopes);
    },
    sortedScopes() {
      return [...this.availableScopes].sort((a, b) => {
        const percentageA = this.getScopePercentage.find(item => item.scope === a)?.percentage || 0;
        const percentageB = this.getScopePercentage.find(item => item.scope === b)?.percentage || 0;
        return percentageB - percentageA; // Descending order
      });
    },
    // New computed property to get the percentage for each scope
    getScopePercentage() {
      return this.availableScopes.map(scope => ({
        scope,
        percentage: this.scopePercentages[scope] || 0
      }));
    },
    getScopeTotal() {
      return (scope) => {
        let B1 = { total: 0, completed: 0, ins_so: 0 };
        let B2 = { total: 0, completed: 0, ins_so: 0 };

        this.filteredChapters.forEach(chapter => {
          const scopeData = this.chapterScopeTaskCounts[chapter.chapt_no]?.[scope];
          if (scopeData) {
            B1.total += scopeData.B1?.total || 0;
            B1.completed += scopeData.B1?.completed || 0;
            B1.ins_so += scopeData.B1?.ins_so || 0;
            B2.total += scopeData.B2?.total || 0;
            B2.completed += scopeData.B2?.completed || 0;
            B2.ins_so += scopeData.B2?.ins_so || 0;
          }
        });

        return { B1, B2 };
      };
    },
    // --- Default (non-custom) Chapter-Scope table, used when ENABLE_CUSTOM_PROGRESS is false ---
    chapterScopeTaskCountsDefault() {
      const taskCounts = {};

      this.mergedTasks.forEach(task => {
        const { chapt_no, scope } = task;

        if (!taskCounts[chapt_no]) {
          taskCounts[chapt_no] = {};
        }
        if (!taskCounts[chapt_no][scope]) {
          taskCounts[chapt_no][scope] = { total: 0, completed: 0, mandatory: 0, main_completed: 0 };
        }

        taskCounts[chapt_no][scope].total++;
        if (task.completed) {
          taskCounts[chapt_no][scope].completed++;
        }
        if (task.manob === 'MT') {
          taskCounts[chapt_no][scope].mandatory++;
          if (task.completed) {
            taskCounts[chapt_no][scope].main_completed++;
          }
        }
      });

      return taskCounts;
    },
    getScopeTotalDefault() {
      return (scope) => {
        let total = 0;
        let completed = 0;
        let mandatory = 0;
        let mandatory_complete = 0;

        this.filteredChapters.forEach(chapter => {
          const scopeData = this.chapterScopeTaskCountsDefault[chapter.chapt_no]?.[scope];
          if (scopeData) {
            total += scopeData.total;
            completed += scopeData.completed;
            mandatory += scopeData.mandatory;
            mandatory_complete += scopeData.main_completed;
          }
        });

        return { total, completed, mandatory, mandatory_complete };
      };
    },
    totalScopeMainCompletedDefault() {
      return Object.values(this.groupedTasksByScope).reduce((acc, tasks) => acc + tasks.main_completed.length, 0);
    },
    totalManobScopePercentageDefault() {
      if (this.totalScopeMandatory === 0) {
        return '100.0%';
      }
      return ((this.totalScopeMainCompletedDefault / this.totalScopeMandatory) * 100).toFixed(1) + '%';
    },
    totalMainCompletedDefault() {
      return this.filteredChapters.reduce((acc, chapter) => acc + chapter.tasks.main_completed.length, 0);
    },
    totalManobPercentageDefault() {
      if (this.totalMandatory === 0) {
        return '100.0%';
      }
      return ((this.totalMainCompletedDefault / this.totalMandatory) * 100).toFixed(1) + '%';
    },
    percentageMandatoryCompletePerScope() {
      return this.sortedScopes.map(scope => {
        const { mandatory, mandatory_complete } = this.getScopeTotalDefault(scope);
        return mandatory ? ((mandatory_complete / mandatory) * 100).toFixed(1) + '%' : '0.0%';
      });
    },
    totalRequiredToPass() {
      return (scope) => {
        // Get the total tasks for the scope using the `getScopeTotal` method
        const { total } = this.getScopeTotal(scope);
        // Calculate the required total based on the scope percentage
        const percentage = this.scopePercentages[scope] || 0;
        return Math.ceil(total * (percentage / 100));
      };
    },
    overallTotalRequiredToPass() {
      return this.availableScopes.reduce((accumulator, scope) => {
        // Add up the total required to pass for each scope
        return accumulator + this.totalRequiredToPass(scope);
      }, 0);
    },
    percentageCompletePerScope() {
      return this.sortedScopes.map(scope => {
        const { total, ins_so } = this.getScopeTotal(scope);
        // Calculate the completion percentage for each scope
        return total ? ((ins_so / total) * 100).toFixed(1) + '%' : '0.0%';
      });
    },
    filteredChaptersWithMandatory() {
      return this.filteredChapters.filter(chapter => {
        const chapterData = this.chapterScopeTaskCounts[chapter.chapt_no];
        if (!chapterData) return false;

        return Object.values(chapterData).some(scopeData =>
          (scopeData.B1?.total || 0) > 0 || (scopeData.B2?.total || 0) > 0
        );
      });
    },
    tickStats() {
      const stats = {};
      this.sortedScopes.forEach(scope => {
        stats[scope] = { B1: { ticks: 0, blueTicks: 0 }, B2: { ticks: 0, blueTicks: 0 } };

        this.filteredChaptersWithMandatory.forEach(chapter => {
          const chapterData = this.chapterScopeTaskCounts[chapter.chapt_no]?.[scope];
          if (!chapterData) return;

          ['B1', 'B2'].forEach(block => {
            const count = chapterData[block];
            if (count?.total > 0) {
              stats[scope][block].ticks++;
              if (count.ins_so > 0) {
                stats[scope][block].blueTicks++;
              }
            }
          });
        });
      });
      return stats;
    },
    overallTickStats() {
      let totalTicks = 0;
      let totalBlue = 0;
      Object.values(this.tickStats).forEach(scopeStats => {
        ['B1', 'B2'].forEach(block => {
          totalTicks += scopeStats[block].ticks;
          totalBlue += scopeStats[block].blueTicks;
        });
      });
      return { totalTicks, totalBlue };
    },
  },
  watch: {
    mergedTasks(newVal) {
      console.log('New value of mergedTasks:', newVal);
    }
  },
  methods: {
    getTickClass(task) {
      return {
        'tick-blue': task.ins_so,
        'tick-green': !task.ins_so && task.completed > 0,
        'tick-black': !task.ins_so && task.completed === 0,
        'tick-bold': task.ins_so || task.completed > 0,
        'tick-large': task.ins_so || task.completed > 0,
      };
    },
    getCompletedScopePercentage(chapter) {
      const chapterCounts = this.chapterScopeTaskCounts[chapter.chapt_no] || {};

      const scopesWithMandatory = Object.keys(chapterCounts).filter(scope => {
        const counts = chapterCounts[scope];
        return (counts.B1.total > 0 || counts.B2.total > 0);
      });

      if (scopesWithMandatory.length === 0) return 0;

      const completedScopes = scopesWithMandatory.filter(scope => {
        const counts = chapterCounts[scope];
        return (counts.B1.ins_so > 0 || counts.B2.ins_so > 0);
      });

      return (completedScopes.length / scopesWithMandatory.length) * 100;
    },
    async fetchTrainee() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const traineeId = localStorage.getItem('trainee_id');

      console.log('id');
      console.log(traineeId);
      try {
        // Assuming you have an API endpoint to fetch task data
        const response = await axios.get(`/api/users/${this.traineeId}`, { headers });
        const traineeData = response.data;

        console.log('data');
        console.log(traineeData);

        this.traineeUID = traineeData.license_no;
        this.traineeName = traineeData.last_name + ', ' + traineeData.first_name;

      } catch (error) {
        console.error('Error fetching trainee data:', error);
        // Handle errors as needed
      }
    },
    getTaskDescription(taskId) {
      const task = this.mergedTasks.find(t => t.task_id === taskId);
      return task ? task.description : 'No description available';
    },
    formatDate(dateString) {
      if (!dateString) return ""; // Handle empty dates gracefully
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB"); // "en-GB" formats to dd/mm/yyyy
    },
    fetchAllAssessmentData() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const projectId = parseInt(localStorage.getItem('project_id'));
      const logbookId = parseInt(localStorage.getItem('logbook_id'));

      const taskRequest = axios.get(`/api/projects/${projectId}/assessment_tasks`, { headers });
      const entryRequest = axios.get(`/api/assessments/logbooks/${logbookId}`, { headers });

      Promise.all([taskRequest, entryRequest])
        .then(([taskResponse, entryResponse]) => {
          this.assessment_tasks = taskResponse.data;
          this.assessments = entryResponse.data;
          this.mergeAssessmentData();
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    },
    mergeAssessmentData() {
      this.mergedAssessments = this.assessment_tasks.map(task => {
        const matchingAssessment = this.assessments.filter(
          assessment => assessment.assessment_task_id === task.assessment_task_id
        );
        return {
          ...task,
          assessments: matchingAssessment,
        };
      })
        .filter(task => task.assessments.length > 0);

      console.log('merged assessments', this.mergedAssessments);
    },
    close() {
      this.$emit('close');
    },
    async fetchChapters() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      try {
        const response = await axios.get(`/api/chapters`, { headers });
        const chaptersData = response.data;

        // Group tasks by chapt_no
        const groupedTasks = {};
        this.mergedTasks.forEach(task => {
          if (!groupedTasks[task.chapt_no]) {
            groupedTasks[task.chapt_no] = {
              all: [],
              manob: [],
              completed: [],
              ins_so: [],
              enabled: [],
              main_completed: [],
              main_ins_so: [],
              additional: [],
              additional_completed: [],
            };
          }
          groupedTasks[task.chapt_no].all.push(task);
          const isMainTask = task.manob === 'MT' && task.is_exam === 0;
          if (isMainTask) { // Checking if the task is manob
            groupedTasks[task.chapt_no].manob.push(task);
            if (task.completed) {
              groupedTasks[task.chapt_no].main_completed.push(task);
            }
            if (task.ins_so) {
              groupedTasks[task.chapt_no].main_ins_so.push(task);
            }
          } else {
            groupedTasks[task.chapt_no].additional.push(task);
            if (task.completed) {
              groupedTasks[task.chapt_no].additional_completed.push(task);
            }
          }

          if (task.enabled) {
            groupedTasks[task.chapt_no].enabled.push(task);
          }
          if (task.completed) {
            groupedTasks[task.chapt_no].completed.push(task);
          }
          if (task.ins_so) {
            groupedTasks[task.chapt_no].ins_so.push(task);
          }
        });

        // Merge chaptersData with groupedTasks
        this.chapters = chaptersData.map(chapter => {
          const tasks = groupedTasks[chapter.chapt_no] || { all: [], manob: [], completed: [], ins_so: [], enabled: [], main_completed: [], main_ins_so: [], additional: [], additional_completed: [], };
          return {
            ...chapter,
            tasks: {
              all: tasks.all,
              manob: tasks.manob,
              completed: tasks.completed,
              ins_so: tasks.ins_so,
              enabled: tasks.enabled,
              main_completed: tasks.main_completed,
              main_ins_so: tasks.main_ins_so,
              additional: tasks.additional,
              additional_completed: tasks.additional_completed,
            }
          };
        });
        this.chapters.sort((a, b) => {
          const chapRegex = /^(\d+)([A-Za-z]*)$/;
          const [, numA, suffixA] = (a.chapt_no || '').match(chapRegex) || [];
          const [, numB, suffixB] = (b.chapt_no || '').match(chapRegex) || [];

          const chapterComparison = Number(numA) - Number(numB);
          if (chapterComparison !== 0) return chapterComparison;

          return (suffixA || '').localeCompare(suffixB || '');
        });

      } catch (error) {
        console.error('Error fetching task data:', error);
      }
    },
  },
  async mounted() {
    this.isVisible = true;
    this.fetchChapters();
    this.fetchTrainee();
    this.fetchAllAssessmentData();
    console.log('Value of mergedTasks:', this.mergedTasks);
  },
}


</script>

<style scoped>
.Task-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 20;
}

.Task-modal {
  background-color: rgb(239, 244, 255);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  width: min(95%, 1600px);
  /* You can adjust the maximum height as needed */
  overflow-y: auto;
  border: 2px solid rgb(83, 83, 83);
  margin-top: 10px;
}

.Task-modal-title {
  margin-bottom: 10px;
  float: left;
  margin-left: 20px;
  color: black;
}

.data-table {
  border-collapse: collapse;
  background-color: rgb(253, 253, 255);
  border: 2px solid rgb(0, 0, 0);
  border-top: none;
  box-shadow: 0;
  margin-top: 20px;
  margin-bottom: 20px;
}

.highlight-green {
  background-color: #b7f8c6;
  color: #155724;
}

.highlight-orange {
  background-color: #ffedb2;
  /* Light orange background */
  color: #6e5405;
}

.data-table td,
.data-table th {
  padding: 10px;
  width: 140px;
  font-size: 16px;
}

.data-table thead th {
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: rgb(233, 233, 233);
}

/* first header row */
.data-table thead tr:first-child th {
  top: 0;
}

/* second header row */
.data-table thead tr:nth-child(2) th {
  top: 46px; /* adjust to match actual height of first row */
}

.data-table thead tr:first-child th::before {
  content: "";
  position: absolute;
  left: -1px;
  right: -1px;
  top: -1px;
  height: 2px;
  background: black;
  z-index: 5;
}

/* fake the missing bottom border while sticky */
.data-table thead th::after {
  content: "";
  position: absolute;
  left: -1px;
  right: -1px;
  bottom: -2px;
  height: 2px;
  background: black;
  z-index: 5;
}

.in-progress {
  background-color: #ffedb2;
  color: #6e5405;
}

.pass {
  background-color: #b7f8c6;
  color: #155724;
  width: 80px;
}

.fail {
  background-color: #ffb2b2;
  /* Light orange background */
  color: #6e0505;
  width: 80px;
}

.submitted {
  background-color: #b7f8c6;
  color: #155724;
}

.data-table th,
td.grey-column {
  background-color: rgb(233, 233, 233)
}

.data-tale th {
  position: sticky;
  z-index: 1;
}

.total-row,
.mandatory-tasks-row {
  border-top: 2px solid black;
  border-bottom: 2px solid black;
  /* Adjust the border color and size as needed */
}

.nav-item:hover {
  cursor: pointer;
  background-color: rgb(221, 221, 221);
  border-radius: 5px;
}

.modal-content-progress {
  max-height: 94vh;
  overflow-y: auto;
}

.fa-window-close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  color: grey;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.fa-window-close:hover {
  color: rgb(87, 87, 87);
  cursor: pointer;
  transform: scale(1.1);
}

span {
  border: none;
}

.b2-border {
  border-left: 2px solid black !important;
}

.tick-blue {
  color: rgb(0, 140, 255);
}

.tick-green {
  color: rgb(0, 163, 0);
}

.tick-black {
  color: black;
}

.tick-bold {
  font-weight: bold;
}

.tick-large {
  font-size: 1.2em;
}

.tick-blue:hover {
  color: rgb(0, 100, 200) !important;
}

.tick-green:hover {
  color: rgb(0, 120, 0) !important;
}

.tick-black:hover {
  color: rgb(60, 60, 60) !important;
}
</style>